import {conText} from "@/utils/configText"
export const columns = (vm) =>{
    return [
        {
            label:'',
            width:50,
            headerAlign:"center",
            align:"center",
            type:'selection',
        },
        {
            label:'报警名称',
            prop:'policeName',
            tooltip:true
        },
        {
            label:'报警类型',
            width:180,
            prop:'policeTypeName',
            tooltip:true
        },
        {
            label:'排序',
            width:100,
            align:"center",
            headerAlign:"center",
            prop:'sort',
        },
        {
            label:'操作人',
            width:160,
            align:"center",
            headerAlign:"center",
            prop:'operator',
        },
        {
            label:'状态',
            width:160,
            align:"center",
            headerAlign:"center",
            prop:'operator',
            render: (h, params) => {
                return h('span',{},params.row.enable ==1 ? "启用":"禁用")
            }
        },
        {
            label:'更新时间',
            width:180,
            prop:'createTime',
            render: (h, params) => {
                return h('span',{},!params.row.params ==1 ? params.row.createTime:"禁用")
            }
        },
        {
            label:'操作',
            width:100,
            align:"center",
            headerAlign:"center",
            fixed:"right",
            render: (h, params) => {
              const look = (h) => {
                  return h('el-link', {
                        props: {
                            type:'primary',
                            underline:false
                        },
                        style: {

                        },
                        on: {
                            click: () => {
                                vm.eidtBtn(params.row);
                            }
                        }
                    }, '编辑');
              };
              const forbtn = (h) => {
                  return h('el-link', {
                        props: {
                            type:'danger',
                            underline:false,
                            disabled:false
                        },
                        style: {
                           
                        },
                        on: {
                            click: () => {
                                vm.deleteBtn(params.row);
                            }
                        }
                    }, "删除");
              };
    
              const buttons = [];
                buttons.push(look(h))
                buttons.push(forbtn(h));
                return h('div', {
                    class:"common-space-around"
                }, buttons);
            }
        }
    ]
}